import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "site-header" }
const _hoisted_2 = {
  class: "nav-cta",
  href: "#contact"
}
const _hoisted_3 = ["aria-expanded"]

import { ref } from "vue";
import { ArrowUpRight, Menu, X } from "lucide-vue-next";
import "@/assets/styles/sidebar.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  setup(__props) {

const isOpen = ref(false);

const close = () => {
  isOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("a", {
        class: "nav-brand",
        href: "#home",
        "aria-label": "Freiraum Startseite",
        onClick: close
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "brand-mark" }, "F", -1),
        _createElementVNode("span", { class: "brand-copy" }, [
          _createElementVNode("strong", null, "FREIRAUM"),
          _createElementVNode("small", null, "Garten · Landschaft · Pflege")
        ], -1)
      ]))]),
      _cache[3] || (_cache[3] = _createStaticVNode("<nav class=\"desktop-nav\" aria-label=\"Hauptnavigation\"><a href=\"#about\">Unternehmen</a><a href=\"#services\">Leistungen</a><a href=\"#references\">Projekte</a><a href=\"#reviews\">Stimmen</a></nav>", 1)),
      _createElementVNode("a", _hoisted_2, [
        _cache[2] || (_cache[2] = _createTextVNode(" Projekt anfragen ", -1)),
        _createVNode(_unref(ArrowUpRight), { size: 17 })
      ]),
      _createElementVNode("button", {
        class: "menu-btn",
        type: "button",
        "aria-label": "Menü öffnen",
        "aria-expanded": isOpen.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
      }, [
        (isOpen.value)
          ? (_openBlock(), _createBlock(_unref(X), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(Menu), { key: 1 }))
      ], 8, _hoisted_3)
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "menu-backdrop",
          onClick: close
        }))
      : _createCommentVNode("", true),
    _createElementVNode("aside", {
      class: _normalizeClass(["mobile-menu", { open: isOpen.value }]),
      "aria-label": "Mobile Navigation"
    }, [
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "menu-kicker" }, "Navigation", -1)),
      _createElementVNode("nav", null, [
        _createElementVNode("a", {
          href: "#home",
          onClick: close
        }, "Start"),
        _createElementVNode("a", {
          href: "#about",
          onClick: close
        }, "Unternehmen"),
        _createElementVNode("a", {
          href: "#services",
          onClick: close
        }, "Leistungen"),
        _createElementVNode("a", {
          href: "#references",
          onClick: close
        }, "Projekte"),
        _createElementVNode("a", {
          href: "#reviews",
          onClick: close
        }, "Kundenstimmen"),
        _createElementVNode("a", {
          href: "#contact",
          onClick: close
        }, "Kontakt")
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, [
        _createTextVNode("Außenräume, die funktionieren."),
        _createElementVNode("br"),
        _createTextVNode("Für Menschen, Teams und Orte.")
      ], -1))
    ], 2)
  ], 64))
}
}

})